import React from "react";
import Navbar from "../components/Nav";
import WishesForm from "../components/WishesForm";
import WishesList from "../components/WishesList";

const Wishes = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-black">
      <Navbar />
      <div className="mt-16 flex flex-col md:flex-row"> {/* Add margin-top here */}
        <div className="w-full md:w-1/2 p-4">
          <div className="bg-white shadow-lg rounded-lg p-6 ">
            <h2 className="text-2xl font-bold mb-4 text-red-600">Create Your Wishes</h2>
            <WishesForm />
          </div>
        </div>
        <div className="w-full md:w-1/2 p-4 bg-gray-50">
          <div className="bg-red-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold mb-4 text-red-600">Live Wishes Feed</h2>
            <WishesList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wishes;
